// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.default-anchor_a29a69e0.default-anchor_a29a69e0 {
  font-weight: 600;
}
.dropdown_a29a69e0 {
  display: grid;
  grid-template-rows: 1fr;
}
.body_a29a69e0 {
  padding: 1.334rem;
}
.body_a29a69e0 [data-overlayscrollbars-contents] {
  overscroll-behavior: contain;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"default-anchor": `default-anchor_a29a69e0`,
	"dropdown": `dropdown_a29a69e0`,
	"body": `body_a29a69e0`
};
export default ___CSS_LOADER_EXPORT___;
